import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { Title } from 'Components/frameworks/title/Title';
import { ActivitiesThematics } from 'Components/widgets/activities-thematics/ActivitiesThematics';
import { AvailabilityBadge } from 'Components/widgets/availability-badge/AvailabilityBadge';
type Props = {
  className?: string;
  hasRentals?: boolean;
  thematics: Array<ActivitiesThematicEntity>;
  trackRentals: () => void;
};
export const ProductActivitiesThematics = ({
  className,
  hasRentals = false,
  thematics,
  trackRentals,
}: Props) => (
  <div className={classnames('flex flex-col gap-20', className)}>
    <div
      className="animation-duration-750 relative isolate animate-fadeIn"
      data-testid="Activities-aside"
    >
      <div className="absolute -z-1 -mt-40 hidden -translate-x-1/2 transform md:flex rtl:left-full">
        <div className="relative left-[30px] right-[30px] z-1 rounded-full border-5 border-white bg-white">
          <AvailabilityBadge className="border-pearl bg-pearl" iconSize="4.375rem" isOnDemand />
        </div>
        <div className="relative rounded-full border-5 border-white">
          <AvailabilityBadge className="border-pearl bg-pearl" iconSize="4.375rem" />
        </div>
      </div>
      <p className="mb-10 text-16 text-mediumGrey" data-testid="Activites-title">
        {t('common.activities.findYourThematic')}
      </p>
      <Title theme="title-brand-n3">{t('common.activities.thematicTitle')}</Title>
    </div>
    <div data-testid="Activities-components">
      <ActivitiesThematics
        hasRentals={hasRentals}
        thematics={thematics as Array<ActivitiesThematicEntity>}
        trackRentals={trackRentals}
      />
    </div>
  </div>
);
